import {HyperDropComponent} from "./HyperDropComponent";

export class HyperDropPopup extends HyperDropComponent {

  isOpen: boolean = false

  onMount(): void {
    this.elements.toggle.addEventListener('click', () => this.open());
    this.elements.backdrop.addEventListener('click', () => this.close());
    this.elements.closeBtn.addEventListener('click', () => this.close());
  }

  listenForEscape(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this.close();
    }
  }

  open() {
    this.elements.popup.classList.add('visible');
    this.elements.backdrop.classList.add('visible');
    document.addEventListener('keydown', (e) => this.listenForEscape(e));
    document.body.classList.add('overflow-y-hidden');
  }

  close() {
    this.elements.popup.classList.remove('visible');
    this.elements.backdrop.classList.remove('visible');
    document.removeEventListener('keydown', (e) => this.listenForEscape(e));
    document.body.classList.remove('overflow-y-hidden');
  }
}
